import { firebaseShared } from "@shared/firebase.js";
import * as firebase from "@shared/firebase.js";
import * as environment from "@shared/environment.js";
import { dlog } from "@shared/utility.js";

let config = null;

function getConfig() {
    return config ? { ...config } : null;
}

function getBackgroundRemovalService() {
    return config?.backgroundRemovalService || null;
}

async function fetchConfig(force = false) {
    if (!force && config !== null) {
        dlog("already fetched config. bailing.");
        return;
    }

    try {
        const collectionRef = firebase.collection(firebaseShared.db, environment.currentConfigCollectionName());
        const docRef = firebase.doc(collectionRef, "config");
        const docSnapshot = await firebaseShared.withRetry(() => firebase.getDoc(docRef));
        if (docSnapshot.exists()) {
            config = docSnapshot.data();
            dlog(`config: ${JSON.stringify(config)}`);
        } else {
            dlog("config document does not exist");
        }
    } catch (error) {
        console.warn("fetchConfig failed after retries:", error);
        return;
    }
}

export { getConfig, getBackgroundRemovalService, fetchConfig };
